import { MNSproCloudApi } from '../..';
import { Period, PeriodCreate, PeriodUpdate } from '../../api/v2';
import { UpdatePeriodModel } from './periods.interfaces';

const getOrganizationApi = (authToken: string) =>
  MNSproCloudApi.V2.OrganizationsApiFactory(
    MNSproCloudApi.V2.createConfiguration(authToken),
  );

export class PeriodsService {
  static async getPeriods(
    authToken: string,
    organizationId: string,
  ): Promise<Period[]> {
    const api = getOrganizationApi(authToken);
    return (await api.getPeriodsAll(organizationId)).data;
  }

  static async getActivePeriod(
    authToken: string,
    organizationId: string,
  ): Promise<Period> {
    const api = getOrganizationApi(authToken);
    return (await api.getActivePeriod(organizationId)).data;
  }

  static async bulkUpdatePeriods(
    authToken: string,
    organizationId: string,
    periodsToCreate: PeriodCreate[],
    periodsToUpdate: UpdatePeriodModel[],
    periodsToDelete: string[],
    activePeriod: string | null,
  ): Promise<void> {
    const api = getOrganizationApi(authToken);

    for (const periodToCreate of periodsToCreate) {
      await api.createPeriod(organizationId, periodToCreate);
    }

    for (const periodToUpdate of periodsToUpdate) {
      await api.updatePeriod(
        organizationId,
        periodToUpdate.periodId,
        periodToUpdate.updateModel,
      );
    }

    for (const periodIdToDelete of periodsToDelete) {
      await api.deletePeriod(organizationId, periodIdToDelete);
    }

    if (activePeriod) {
      await api.activatePeriod(organizationId, activePeriod);
    }
  }
}
